import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class CardSlider {
  constructor(cardSlider) {
    Swiper.use([Navigation]);

    let sliderContainer = cardSlider.parentElement;
    let prevButton = sliderContainer.querySelector('.js-button-prev');
    let nextButton = sliderContainer.querySelector('.js-button-next');

    var cardSwiper = new Swiper(cardSlider, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      grabCursor: true,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 50,
      breakpoints: {
        // when window width is >= 768 (medium screen)
        768: {
          spaceBetween: 30,
          slidesOffsetAfter: 50,
          slidesOffsetBefore: 0,
        },
      },
      init: false,
    });

    cardSwiper.on('init', () => {
      this.toggleNavigation(cardSwiper, prevButton, nextButton);
    });

    cardSwiper.on('resize', () => {
      this.toggleNavigation(cardSwiper, prevButton, nextButton);
    });

    cardSwiper.init();
  }

  toggleNavigation(swiper, prevButton, nextButton) {
    const totalSlides = swiper.slides.length;
    const lastSlide = swiper.slides[totalSlides - 1];

    if (!lastSlide) {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
      return;
    }

    const lastSlideRightEdge = lastSlide.offsetLeft + lastSlide.offsetWidth;
    const swiperRightEdge = swiper.width + swiper.slides[0].offsetLeft;

    if (lastSlideRightEdge > swiperRightEdge) {
      prevButton.style.display = '';
      nextButton.style.display = '';
    } else {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
    }
  }

}

document.addEventListener("DOMContentLoaded", function() {
  const cardSliders = document.querySelectorAll('.js-card-slider');
  if (cardSliders.length > 0) {
    const cardSlidersArray = [...cardSliders];

    cardSlidersArray.forEach((cardSlider) => {
      new CardSlider(cardSlider)
    });
  }
});
